import { jsx as _jsx } from "react/jsx-runtime";
import { extendCommonGroupsStylesheet } from "@devowl-wp/web-cookie-banner";
import { useBannerStylesheet } from "../../../hooks/banner/useBannerStylesheet.js";
import { useBannerOrBlocker } from "../../../hooks/useBannerOrBlocker.js";
import { Checkbox } from "../checkbox.js";
const GcmConsentType = ({ type, isDisabled, isBold })=>{
    const { Cookie } = useBannerStylesheet().extend(...extendCommonGroupsStylesheet);
    const { activeAction, gcmConsent, updateGcmConsentTypeChecked, group: { descriptionFontSize }, i18n: { gcm: { purposes: { [type]: purposeText } } } } = useBannerOrBlocker();
    return /*#__PURE__*/ _jsx(Cookie, {
        children: /*#__PURE__*/ _jsx(Checkbox, {
            isChecked: gcmConsent.indexOf(type) > -1,
            isDisabled: isDisabled || activeAction === "history",
            fontSize: descriptionFontSize,
            onToggle: (state)=>updateGcmConsentTypeChecked(type, state),
            children: /*#__PURE__*/ _jsx("span", {
                style: {
                    fontWeight: isBold ? "bold" : undefined
                },
                children: purposeText
            })
        })
    });
};
export { GcmConsentType };
